import React from "react";
import { useNavigate } from "react-router-dom";
import { BusinessLogo } from "../../../images";

const FEATURES = [
  {
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_217_3564)">
          <path
            d="M29.6428 24.36C28.5561 26.2173 25.9521 26.8387 24.1415 25.68C23.8281 25.4867 23.7295 25.0773 23.9215 24.7627C24.1161 24.448 24.5241 24.3493 24.8388 24.5427C25.4455 24.9147 26.1628 25.028 26.8548 24.8627C27.5481 24.696 28.1335 24.2707 28.5041 23.664C28.8761 23.056 28.9895 22.34 28.8241 21.6467C28.6575 20.9533 28.2321 20.368 27.6255 19.9973L26.6308 19.3867C26.3815 19.2347 26.2615 18.9373 26.3335 18.6533C26.5535 17.792 26.6655 16.9 26.6655 16.0013C26.6655 15.1027 26.5535 14.2107 26.3335 13.3493C26.2601 13.0667 26.3815 12.768 26.6321 12.616L27.6255 12.0067C28.8775 11.2387 29.2735 9.59333 28.5041 8.34C27.7815 7.10133 26.0428 6.68533 24.8375 7.45867L23.8428 8.06933C23.5921 8.22267 23.2721 8.19333 23.0521 8.00133C21.9055 6.98933 20.5868 6.25067 19.1361 5.80533C18.8561 5.72 18.6641 5.46133 18.6641 5.168V4.00267C18.6641 2.532 17.4681 1.336 15.9975 1.336C14.5268 1.336 13.3308 2.532 13.3308 4.00267V5.168C13.3308 5.46133 13.1401 5.72 12.8601 5.80533C11.4095 6.25067 10.0908 6.98933 8.94279 8.00133C8.72279 8.196 8.40279 8.22133 8.15345 8.06933L7.15745 7.45867C5.90279 6.68933 4.25879 7.08533 3.49079 8.34C2.72279 9.59333 3.11745 11.2387 4.37212 12.0067L5.36545 12.616C5.61479 12.7693 5.73479 13.0667 5.66279 13.3493C5.44279 14.2107 5.33079 15.1027 5.33079 16.0013C5.33079 16.9 5.44279 17.7933 5.66279 18.6533C5.73479 18.9373 5.61479 19.2347 5.36545 19.3867L4.37212 19.996C3.13345 20.72 2.71745 22.456 3.49079 23.664C3.86279 24.2707 4.44945 24.696 5.14145 24.8627C5.83345 25.0267 6.54946 24.9133 7.15745 24.5427C7.47212 24.3507 7.88146 24.4507 8.07479 24.7627C8.26812 25.076 8.16812 25.488 7.85479 25.68C7.21745 26.0693 6.50145 26.2693 5.77212 26.2693C4.39479 26.276 3.06545 25.5413 2.35479 24.3587C1.19479 22.548 1.81879 19.9427 3.67612 18.8573L4.26012 18.5C4.08679 17.6813 3.99879 16.8427 3.99879 15.9987C3.99879 15.1547 4.08679 14.316 4.26012 13.4987L3.67612 13.1413C1.79612 11.9893 1.20279 9.52267 2.35479 7.64133C3.50545 5.76133 5.97479 5.168 7.85479 6.32L8.44012 6.67867C9.51079 5.808 10.7041 5.13867 11.9975 4.68267V4C11.9975 1.79467 13.7921 0 15.9975 0C18.2028 0 19.9975 1.79467 19.9975 4V4.68267C21.2908 5.13867 22.4841 5.808 23.5548 6.67867L24.1388 6.32C25.9508 5.16133 28.5535 5.784 29.6401 7.64133C30.7921 9.52267 30.2001 11.9893 28.3201 13.1413L27.7361 13.4987C27.9095 14.3173 27.9961 15.156 27.9961 15.9987C27.9961 16.8413 27.9095 17.6813 27.7361 18.5L28.3201 18.8587C30.1761 19.9427 30.8001 22.5493 29.6401 24.3587L29.6428 24.36ZM21.8921 17.3307C22.2521 17.3733 22.5868 17.1067 22.6268 16.7387C22.6535 16.496 22.6668 16.2507 22.6668 16.0013C22.6668 12.3253 19.6761 9.33467 16.0001 9.33467C12.3241 9.33467 9.33346 12.3253 9.33346 16.0013C9.33346 16.252 9.34679 16.4987 9.37346 16.7413C9.41079 17.0827 9.70012 17.3347 10.0361 17.3347C10.4295 17.3373 10.7455 16.9867 10.7001 16.5947C10.6788 16.4 10.6681 16.2013 10.6681 16.0013C10.6681 13.06 13.0601 10.668 16.0015 10.668C18.9428 10.668 21.3348 13.06 21.3348 16.0013C21.3348 16.2027 21.3228 16.4013 21.3028 16.5973C21.2641 16.9627 21.5268 17.292 21.8921 17.3307ZM15.0655 22.5733C14.5441 23.0947 14.5441 23.9387 15.0655 24.4587C15.5868 24.98 16.4308 24.98 16.9508 24.4587C17.4721 23.9373 17.4721 23.0933 16.9508 22.5733C16.4295 22.0533 15.5855 22.052 15.0655 22.5733ZM20.4175 24.1573C21.9015 25.7173 22.7228 27.5987 22.6748 29.352C22.6681 29.5387 22.6575 29.724 22.6388 29.9107C22.6055 30.276 22.4401 30.6253 22.1735 30.8893C21.5601 31.4973 20.5801 31.5213 19.9455 30.9387L18.1868 29.3333H16.6748V31.3333C16.6748 31.7013 16.3761 32 16.0081 32C15.6401 32 15.3415 31.7013 15.3415 31.3333V29.3333H13.8335L12.0815 30.9693C11.7695 31.2627 11.3735 31.408 10.9775 31.408C10.2055 31.4307 9.44012 30.7667 9.37079 29.9787C9.10545 27.6667 10.3161 25.492 11.5975 24.1573C11.8828 21.476 12.6868 18.444 14.1148 14.6427C14.4148 13.848 15.1575 13.3347 16.0068 13.3347C16.8561 13.3347 17.5988 13.848 17.8975 14.6413C19.3055 18.384 20.1095 21.416 20.4175 24.1573ZM21.3415 29.3133C21.3801 27.8613 20.6401 26.2627 19.3081 24.9293C19.2001 24.8213 19.1321 24.6787 19.1161 24.5253C18.8401 21.84 18.0575 18.8493 16.6508 15.1107C16.4961 14.6987 16.1188 14.6667 16.0081 14.6667C15.8961 14.6667 15.5188 14.6987 15.3641 15.1107C13.9361 18.9107 13.1535 21.9 12.9015 24.52C12.8868 24.676 12.8175 24.8227 12.7055 24.9333C11.5895 26.0267 10.4748 27.8867 10.6975 29.8267C10.7215 30.0453 11.0135 30.1547 11.1721 29.9947L13.1175 28.18C13.2415 28.064 13.4041 28 13.5721 28H18.4481C18.6148 28 18.7748 28.0627 18.8975 28.1747L20.8468 29.9547C21.0095 30.1107 21.2961 30 21.3148 29.78C21.3308 29.6227 21.3415 29.468 21.3441 29.312L21.3415 29.3133Z"
            fill="#00663F"
          />
        </g>
        <defs>
          <clipPath id="clip0_217_3564">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Instant Account Setup",
    desc: "Create a new trading account in minutes. The bot collects your BVN, creates your CSCS account, and gives you your Clearing House Number (CHN)—automatically.",
  },
  {
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_202_3542)">
          <path
            d="M26 5.33333H20V4C20 1.79467 18.2053 0 16 0C13.7947 0 12 1.79467 12 4V5.33333H6C2.692 5.33333 0 8.02533 0 11.3333V26C0 29.308 2.692 32 6 32H26C29.308 32 32 29.308 32 26V11.3333C32 8.02533 29.308 5.33333 26 5.33333ZM13.3333 4C13.3333 2.52933 14.5293 1.33333 16 1.33333C17.4707 1.33333 18.6667 2.52933 18.6667 4V8C18.6667 8.736 18.0693 9.33333 17.3333 9.33333H14.6667C13.9307 9.33333 13.3333 8.736 13.3333 8V4ZM30.6667 26C30.6667 28.5733 28.5733 30.6667 26 30.6667H6C3.42667 30.6667 1.33333 28.5733 1.33333 26V11.3333C1.33333 8.76 3.42667 6.66667 6 6.66667H12V8C12 9.47067 13.196 10.6667 14.6667 10.6667H17.3333C18.804 10.6667 20 9.47067 20 8V6.66667H26C28.5733 6.66667 30.6667 8.76 30.6667 11.3333V26ZM12 14.6667H8C6.52933 14.6667 5.33333 15.8627 5.33333 17.3333V24C5.33333 25.4707 6.52933 26.6667 8 26.6667H12C13.4707 26.6667 14.6667 25.4707 14.6667 24V17.3333C14.6667 15.8627 13.4707 14.6667 12 14.6667ZM13.3333 24C13.3333 24.736 12.736 25.3333 12 25.3333H8C7.264 25.3333 6.66667 24.736 6.66667 24V17.3333C6.66667 16.5973 7.264 16 8 16H12C12.736 16 13.3333 16.5973 13.3333 17.3333V24ZM26.6667 20.6667C26.6667 21.0347 26.368 21.3333 26 21.3333H18C17.632 21.3333 17.3333 21.0347 17.3333 20.6667C17.3333 20.2987 17.632 20 18 20H26C26.368 20 26.6667 20.2987 26.6667 20.6667ZM26.6667 15.3333C26.6667 15.7013 26.368 16 26 16H18C17.632 16 17.3333 15.7013 17.3333 15.3333C17.3333 14.9653 17.632 14.6667 18 14.6667H26C26.368 14.6667 26.6667 14.9653 26.6667 15.3333ZM24 26C24 26.368 23.7013 26.6667 23.3333 26.6667H18C17.632 26.6667 17.3333 26.368 17.3333 26C17.3333 25.632 17.632 25.3333 18 25.3333H23.3333C23.7013 25.3333 24 25.632 24 26Z"
            fill="#00663F"
          />
        </g>
        <defs>
          <clipPath id="clip0_202_3542">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Secure KYC",
    desc: "Upload your government-issued ID directly in the chat. Your documents are encrypted and handled in compliance with Nigeria's Data Protection Act.",
  },
  {
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_202_3547)">
          <g clip-path="url(#clip1_202_3547)">
            <path
              d="M4 20.6667C4 18.0933 6.09333 16 8.66667 16C11.24 16 13.3333 18.0933 13.3333 20.6667C13.3333 21.0347 13.0347 21.3333 12.6667 21.3333C12.2987 21.3333 12 21.0347 12 20.6667C12 18.8293 10.5053 17.3333 8.66667 17.3333C6.828 17.3333 5.33333 18.8293 5.33333 20.6667C5.33333 21.0347 5.03467 21.3333 4.66667 21.3333C4.29867 21.3333 4 21.0347 4 20.6667ZM5.33333 11.3333C5.33333 9.496 6.828 8 8.66667 8C10.5053 8 12 9.496 12 11.3333C12 13.1707 10.5053 14.6667 8.66667 14.6667C6.828 14.6667 5.33333 13.1707 5.33333 11.3333ZM6.66667 11.3333C6.66667 12.436 7.564 13.3333 8.66667 13.3333C9.76933 13.3333 10.6667 12.436 10.6667 11.3333C10.6667 10.2307 9.76933 9.33333 8.66667 9.33333C7.564 9.33333 6.66667 10.2307 6.66667 11.3333ZM31.3333 20C30.9653 20 30.6667 20.2987 30.6667 20.6667C30.6667 23.24 28.5733 25.3333 26 25.3333H6C3.42667 25.3333 1.33333 23.24 1.33333 20.6667V8.66667C1.33333 6.09333 3.42667 4 6 4H16.6667C17.0347 4 17.3333 3.70133 17.3333 3.33333C17.3333 2.96533 17.0347 2.66667 16.6667 2.66667H6C2.692 2.66667 0 5.35867 0 8.66667V20.6667C0 23.9747 2.692 26.6667 6 26.6667H15.3333V30.6667H8.66667C8.29867 30.6667 8 30.9653 8 31.3333C8 31.7013 8.29867 32 8.66667 32H23.3333C23.7013 32 24 31.7013 24 31.3333C24 30.9653 23.7013 30.6667 23.3333 30.6667H16.6667V26.6667H26C29.308 26.6667 32 23.9747 32 20.6667C32 20.2987 31.7013 20 31.3333 20ZM32 11.3333V14C32 16.5733 29.9067 18.6667 27.3333 18.6667H22C19.4267 18.6667 17.3333 16.5733 17.3333 14V11.3333C17.3333 9.47867 18.4293 7.88667 20 7.13467V4.66667C20 2.09333 22.0933 0 24.6667 0C27.24 0 29.3333 2.09333 29.3333 4.66667V7.13467C30.904 7.88667 32 9.47867 32 11.3333ZM21.3333 6.73467C21.5533 6.70267 21.772 6.66667 22 6.66667H27.3333C27.5613 6.66667 27.78 6.70267 28 6.73467V4.66667C28 2.82933 26.5053 1.33333 24.6667 1.33333C22.828 1.33333 21.3333 2.82933 21.3333 4.66667V6.73467ZM30.6667 11.3333C30.6667 9.496 29.172 8 27.3333 8H22C20.1613 8 18.6667 9.496 18.6667 11.3333V14C18.6667 15.8373 20.1613 17.3333 22 17.3333H27.3333C29.172 17.3333 30.6667 15.8373 30.6667 14V11.3333ZM24.6667 11.3333C23.9307 11.3333 23.3333 11.9307 23.3333 12.6667C23.3333 13.4027 23.9307 14 24.6667 14C25.4027 14 26 13.4027 26 12.6667C26 11.9307 25.4027 11.3333 24.6667 11.3333Z"
              fill="#00663F"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_202_3547">
            <rect width="32" height="32" fill="white" />
          </clipPath>
          <clipPath id="clip1_202_3547">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Login with BVN + Email",
    desc: "Existing NGX investors can securely log in using their Bank Verification Number and registered email—no extra passwords.",
  },
  {
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_217_3574)">
          <path
            d="M26 0H12.6667C9.35867 0 6.66667 2.692 6.66667 6V9.33333H5.33333C2.392 9.33333 0 11.7253 0 14.6667V28C0 30.2053 1.79467 32 4 32H26C29.308 32 32 29.308 32 26V6C32 2.692 29.308 0 26 0ZM6.66667 28C6.66667 29.4707 5.47067 30.6667 4 30.6667C2.52933 30.6667 1.33333 29.4707 1.33333 28V14.6667C1.33333 12.4613 3.128 10.6667 5.33333 10.6667H6.66667V28ZM30.6667 26C30.6667 28.5733 28.5733 30.6667 26 30.6667H6.97867C7.61333 29.9587 8 29.024 8 28V6C8 3.42667 10.0933 1.33333 12.6667 1.33333H26C28.5733 1.33333 30.6667 3.42667 30.6667 6V26ZM28 10C28 10.368 27.7013 10.6667 27.3333 10.6667H20.6667C20.2987 10.6667 20 10.368 20 10C20 9.632 20.2987 9.33333 20.6667 9.33333H27.3333C27.7013 9.33333 28 9.632 28 10ZM28 15.3333C28 15.7013 27.7013 16 27.3333 16H11.3333C10.9653 16 10.6667 15.7013 10.6667 15.3333C10.6667 14.9653 10.9653 14.6667 11.3333 14.6667H27.3333C27.7013 14.6667 28 14.9653 28 15.3333ZM28 20.6667C28 21.0347 27.7013 21.3333 27.3333 21.3333H11.3333C10.9653 21.3333 10.6667 21.0347 10.6667 20.6667C10.6667 20.2987 10.9653 20 11.3333 20H27.3333C27.7013 20 28 20.2987 28 20.6667ZM28 26C28 26.368 27.7013 26.6667 27.3333 26.6667H11.3333C10.9653 26.6667 10.6667 26.368 10.6667 26C10.6667 25.632 10.9653 25.3333 11.3333 25.3333H27.3333C27.7013 25.3333 28 25.632 28 26ZM12.6667 10.6667H15.3333C16.436 10.6667 17.3333 9.76933 17.3333 8.66667V6C17.3333 4.89733 16.436 4 15.3333 4H12.6667C11.564 4 10.6667 4.89733 10.6667 6V8.66667C10.6667 9.76933 11.564 10.6667 12.6667 10.6667ZM12 6C12 5.632 12.2987 5.33333 12.6667 5.33333H15.3333C15.7013 5.33333 16 5.632 16 6V8.66667C16 9.03467 15.7013 9.33333 15.3333 9.33333H12.6667C12.2987 9.33333 12 9.03467 12 8.66667V6Z"
            fill="#00663F"
          />
        </g>
        <defs>
          <clipPath id="clip0_217_3574">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    title: "Automated Reporting",
    desc: "New account summaries are shared with NGX and your chosen broker, so everyone stays informed without manual follow-ups.",
  },
  {
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.6667 16C10.6667 18.9413 13.0587 21.3333 16 21.3333C18.9413 21.3333 21.3333 18.9413 21.3333 16C21.3333 13.0586 18.9413 10.6666 16 10.6666C13.0587 10.6666 10.6667 13.0586 10.6667 16ZM20 16C20 18.2053 18.2053 20 16 20C13.7947 20 12 18.2053 12 16C12 13.7946 13.7947 12 16 12C18.2053 12 20 13.7946 20 16ZM5.33333 9.3333C6.06933 9.3333 6.66667 9.93063 6.66667 10.6666C6.66667 11.4026 6.06933 12 5.33333 12C4.59733 12 4 11.4026 4 10.6666C4 9.93063 4.59733 9.3333 5.33333 9.3333ZM28 21.3333C28 22.0693 27.4027 22.6666 26.6667 22.6666C25.9307 22.6666 25.3333 22.0693 25.3333 21.3333C25.3333 20.5973 25.9307 20 26.6667 20C27.4027 20 28 20.5973 28 21.3333ZM0 20.6666V11.3333C0 8.0253 2.692 5.3333 6 5.3333H30.2067L26.7693 1.89597C26.5093 1.63597 26.5093 1.2133 26.7693 0.953301C27.0293 0.693301 27.452 0.693301 27.712 0.953301L31.424 4.6653C31.7213 4.96263 31.9853 5.3333 31.9853 5.99997C31.9853 6.66663 31.7213 7.0373 31.424 7.33463L27.712 11.0466C27.5813 11.1773 27.4107 11.2413 27.24 11.2413C27.0693 11.2413 26.8987 11.176 26.768 11.0466C26.508 10.7866 26.508 10.364 26.768 10.104L30.2053 6.66663H6C3.42667 6.66663 1.33333 8.75997 1.33333 11.3333V20.6666C1.33333 21.0346 1.03467 21.3333 0.666667 21.3333C0.298667 21.3333 0 21.0346 0 20.6666ZM32 11.3333V20.6666C32 23.9746 29.308 26.6666 26 26.6666H1.79333L5.23067 30.104C5.49067 30.364 5.49067 30.7866 5.23067 31.0466C5.1 31.1773 4.92933 31.2413 4.75867 31.2413C4.588 31.2413 4.41733 31.176 4.28667 31.0466L0.574667 27.3346C0.277333 27.0373 0.0133333 26.6666 0.0133333 26C0.0133333 25.3333 0.277333 24.9626 0.574667 24.6653L4.28667 20.9533C4.54667 20.6933 4.96933 20.6933 5.22933 20.9533C5.48933 21.2133 5.48933 21.636 5.22933 21.896L1.792 25.3333H25.9987C28.572 25.3333 30.6653 23.24 30.6653 20.6666V11.3333C30.6653 10.9653 30.964 10.6666 31.332 10.6666C31.7 10.6666 32 10.9653 32 11.3333Z"
          fill="#00663F"
        />
      </svg>
    ),
    title: "Trade Facilitation",
    desc: "After account creation, we help you connect with a stockbroker to start trading—a seamless hand-off to complete your journey.",
  },
];

const STEPS = [
  {
    num: "1",
    title: "Start a Chat",
    desc: "Open WhatsApp and send a message to the official NGX Traderbot number.",
  },
  {
    num: "2",
    title: "Follow the Prompts",
    desc: 'Choose "Create New Account" or "Login." The bot guides you through BVN verification, KYC document upload, and CSCS account creation.',
  },
  {
    num: "3",
    title: "Get Your CHN & Start Trading",
    desc: "Once your account is ready, you'll receive your Clearing House Number and broker details. You can then access market data and, with your broker, start trading.",
  },
];

const FAQS = [
  {
    q: "What is NGX Traderbot?",
    a: "An official WhatsApp‑based assistant from the Nigerian Exchange Group that lets you open a trading account, complete KYC, and access market information—all within WhatsApp, with no app download required.",
  },
  {
    q: "How do I start?",
    a: "Save the official NGX Traderbot WhatsApp number and send a message. The bot will guide you through creating a new account or logging in as an existing investor.",
  },
  {
    q: "Can existing investors log in?",
    a: "Yes. Select “Login with Existing Account” and provide your BVN and registered email. Your details are verified against NGX’s platform.",
  },
  {
    q: "How do I create a new account?",
    a: "Follow the prompts: provide your BVN, upload a government‑issued ID, and the system automatically creates your CSCS account and returns your Clearing House Number (CHN). The process takes a few minutes.",
  },
  {
    q: "Is my data secure?",
    a: "Yes. All information, including BVN and ID documents, is encrypted in transit and at rest, handled in compliance with Nigeria’s Data Protection Act and international security standards.",
  },
  {
    q: "Do I need a broker to trade?",
    a: "Yes. Trading on NGX requires a licensed stockbroker. NGX Traderbot helps you by passing your CHN and profile to your chosen broker after account creation.",
  },
  {
    q: "What if I need help?",
    a: "Support is available via the WhatsApp chat (during business hours) or by emailing support@ngxtradebot.ng.",
  },
  {
    q: "Is it available 24/7?",
    a: "The chatbot operates 24/7 for account creation and information. Certain verifications and broker hand‑offs may occur during business hours; you will receive updates as your account progresses.",
  },
];

function FAQItem({ q, a }) {
  const [open, setOpen] = React.useState(false);
  return (
    <div
      className="p-4 lg:p-6 cursor-pointer rounded-xl bg-white shadow-md shadow-[#76BB2A]/10"
      onClick={() => setOpen(!open)}
    >
      <div className="flex justify-between items-center gap-3 text-base lg:text-[18px] font-semibold text-[#222222]">
        <span className="text-left">{q}</span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="flex-shrink-0 transition-transform duration-200"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </div>
      {open && (
        <div className="text-base lg:text-lg text-[#222222] !leading-relaxed mt-4">
          {a}
        </div>
      )}
    </div>
  );
}

const BtnPrimary = ({ onClick, children, className = "" }) => (
  <button
    onClick={onClick}
    className={`bg-[#76BB2A] text-white border-none py-2.5 px-5 rounded-lg text-sm font-semibold cursor-pointer transition-colors whitespace-nowrap hover:bg-[#96e245] ${className}`}
  >
    {children}
  </button>
);

const BtnOutline = ({ onClick, children, className = "" }) => (
  <button
    onClick={onClick}
    className={`bg-white text-gray-900 border border-[#76BB2A] py-2.5 px-5 rounded-lg text-sm font-medium cursor-pointer transition-colors whitespace-nowrap hover:border-[#96e245] ${className}`}
  >
    {children}
  </button>
);

export default function TraderbotLanding() {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);

  const goSignIn = () => navigate("/traderbot-by-ngx/sign-in");

  const scrollTo = (id) => {
    setMobileMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="font-['Source_Sans_3',_'Manrope',_sans-serif] text-gray-900 bg-white min-h-screen box-border">
      {/* NAV */}
      <nav className="sticky top-0 z-[100] bg-white border-b border-gray-100">
        <div className="max-w-[1280px] mx-auto flex items-center justify-between py-3.5 px-6">
          <div
            className="flex items-center gap-2 cursor-pointer font-bold text-gray-900"
            onClick={() => scrollTo("tb-hero")}
          >
            <img
              src={BusinessLogo}
              alt="Traderbot"
              className="w-8 h-8 rounded-full"
            />
            <span className="text-xl">Traderbot by NGX</span>
          </div>

          {/* Desktop nav links */}
          <div
            className={`
            flex items-center gap-8
            md:flex
            ${
              mobileMenuOpen
                ? "!flex flex-col absolute top-full left-0 right-0 bg-white py-5 px-6 gap-4 border-b border-gray-200 shadow-md z-50"
                : "max-md:hidden"
            }
          `}
          >
            <button
              onClick={() => scrollTo("tb-hero")}
              className="bg-transparent border-none text-base text-[#00663F] cursor-pointer p-0 font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollTo("tb-features")}
              className="bg-transparent border-none text-base text-gray-500 cursor-pointer p-0 font-medium hover:text-[#00663F]"
            >
              Features
            </button>
            <button
              onClick={() => scrollTo("tb-how")}
              className="bg-transparent border-none text-base text-gray-500 cursor-pointer p-0 font-medium hover:text-[#00663F]"
            >
              How It Works
            </button>
            <button
              onClick={() => scrollTo("tb-footer")}
              className="bg-transparent border-none text-base text-gray-500 cursor-pointer p-0 font-medium hover:text-[#00663F]"
            >
              Contact Us
            </button>
            {/* Mobile-only actions inside dropdown */}
            <div className="hidden max-md:flex flex-col gap-2 mt-2">
              <BtnOutline onClick={goSignIn}>Sign In</BtnOutline>
              <BtnPrimary onClick={goSignIn}>
                Get Started on WhatsApp
              </BtnPrimary>
            </div>
          </div>

          {/* Desktop actions */}
          <div className="flex items-center gap-3 max-md:hidden">
            <BtnOutline onClick={goSignIn}>Sign In</BtnOutline>
            <BtnPrimary onClick={goSignIn}>Get Started on WhatsApp</BtnPrimary>
          </div>

          {/* Hamburger */}
          <button
            className="hidden max-md:block bg-transparent border-none cursor-pointer p-1"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              {mobileMenuOpen ? (
                <path d="M6 6l12 12M6 18L18 6" />
              ) : (
                <>
                  <line x1="3" y1="6" x2="21" y2="6" />
                  <line x1="3" y1="12" x2="21" y2="12" />
                  <line x1="3" y1="18" x2="21" y2="18" />
                </>
              )}
            </svg>
          </button>
        </div>
      </nav>

      {/* HERO */}
      <section
        id="tb-hero"
        className="bg-gradient-to-br from-green-50 via-white to-green-50 py-16 lg:py-20 px-6"
      >
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 max-w-xl lg:max-w-[670px] text-center lg:text-left">
            <h1 className="text-3xl sm:text-4xl lg:text-[54px] lg:max-w-[520px] font-bold !leading-[120%] mb-5 text-gray-900">
              AI-Powered WhatsApp Trading Assistant for NGX
            </h1>
            <p className="text-base md:text-lg !leading-[140%] text-[#222222] mb-7">
              A secure, official WhatsApp channel that lets you create a trading
              account, complete KYC, and access market insights—right from your
              phone. No app download required.
            </p>
            <div className="flex gap-3 justify-center lg:justify-start flex-col sm:flex-row">
              <BtnOutline onClick={goSignIn}>Sign In</BtnOutline>
              <BtnPrimary onClick={goSignIn}>
                Get Started on WhatsApp
              </BtnPrimary>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <img
              src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1774625376/ngx/Content_bt16ev.png"
              alt="NGX Trade Bot"
              className="max-w-full h-auto rounded-2xl"
            />
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section id="tb-features" className="py-20 px-6 bg-[#F5FCE980]">
        <div className="max-w-[1280px] mx-auto flex flex-col-reverse lg:flex-row items-center gap-10 lg:gap-16">
          {/* Phone mockup */}
          <div className="flex-1 mx-auto lg:mx-0 flex justify-center">
            <img
              src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1774861635/ngx/Frame_71_ugunkx.png"
              alt="phone_img"
              className="max-w-[375px] w-full"
            />
          </div>

          {/* Features content */}
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl lg:text-[40px] text-center lg:text-left  font-bold mb-3 text-black !leading-[120%]">
              Powerful Features, Simplified for You.
            </h2>
            <p className="text-[18px] lg:text-[20px] text-[#222222] leading-relaxed mb-8">
              Built as an official NGX channel, Traderbot allows you to open
              accounts, complete KYC, and stay connected to the market, all
              within WhatsApp, with enterprise-grade security and reliability.
            </p>
            <div className="flex flex-col gap-8">
              {FEATURES.map((f, i) => (
                <div className="flex gap-4 items-start" key={i}>
                  <div className="flex-shrink-0 w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center">
                    {f.icon}
                  </div>
                  <div>
                    <h4 className="text-base lg:text-[18px] font-semibold mb-3 text-black">
                      {f.title}
                    </h4>
                    <p className="text-base text-[#222222] leading-normal">
                      {f.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="tb-how" className="py-20 px-6 bg-white">
        <div className="max-w-[1280px] mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-[40px] font-bold mb-3 text-gray-900">
            How It Works
          </h2>
          <p className="text-[18px] lg:text-[20px] text-[#222222] mb-10">
            Everything you need to manage, automate, and optimize your WhatsApp
            trading interactions in one platform.
          </p>
          <div className="bg-[#00663F] p-9 rounded-[14px]">
            <div className="flex flex-col md:flex-row gap-6 items-center md:items-stretch justify-center mb-8 ">
              {STEPS.map((s, i) => (
                <div
                  className="bg-white border-2 border-gray-200 rounded-2xl py-8 px-6 flex-1 max-w-[340px] text-center mx-auto md:mx-0"
                  key={i}
                >
                  <div className="w-10 h-10 flex items-center justify-center font-extrabold text-xl md:text-xl lg:text-2xl text-[#76BB2A] mx-auto mb-4">
                    {s.num}
                  </div>
                  <h4 className="text-lg lg:text-xl font-bold mb-3 text-[#0E121B]">
                    {s.title}
                  </h4>
                  <p className="text-base text-[#222222E5] !leading-[24px]">
                    {s.desc}
                  </p>
                </div>
              ))}
            </div>
            <BtnOutline onClick={goSignIn} className="mt-2">
              Sign In
            </BtnOutline>
          </div>
        </div>
      </section>

      {/* WHY */}
      <section className="py-20 px-6 bg-[#F5FCE980]">
        <div className="max-w-[1280px] mx-auto flex flex-col-reverse md:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <img
              src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1774636889/ngx/Frame_320_snyzpv.png"
              alt=""
              className="max-w-full h-auto rounded-2xl"
            />
          </div>
          <div className="flex-1">
            <h2 className="text-3xl md:text-4xl lg:text-[40px] text-center md:text-left font-bold mb-6 text-[#000000E5]">
              Why NGX Traderbot?
            </h2>
            <div className="mb-6">
              <h4 className="text-base lg:text-lg font-bold mb-3 text-black">
                Trusted by the Nigerian Exchange Group
              </h4>
              <p className="text-[16px] text-[#222222] !leading-[18px]">
                As an official NGX channel, you can be confident you're
                interacting with a verified source—reducing the risk of fraud or
                impersonation.
              </p>
            </div>
            <div>
              <h4 className="text-base lg:text-lg font-bold mb-3 text-black">
                Built for Where You Already Are
              </h4>
              <p className="text-[16px] text-[#222222] !leading-[18px]">
                Over 95% of Nigerians use WhatsApp. Now, the capital market
                comes to you.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="tb-faq" className="py-20 px-6 bg-white">
        <div className="max-w-[1280px] mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-[40px] font-bold mb-3 text-black">
            Frequently Asked Questions
          </h2>
          <p className="text-lg lg:text-[20px] text-[#222222] mb-10">
            Everything you need to know about the NGX Traderbot platform and how
            it works.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 text-left. bg-[#F6FAF2] p-6">
            <div className="space-y-4">
              {FAQS.slice(0, 4).map((f, i) => (
                <FAQItem key={i} q={f.q} a={f.a} />
              ))}
            </div>
            <div className="space-y-4">
              {FAQS.slice(4).map((f, i) => (
                <FAQItem key={i} q={f.q} a={f.a} />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer id="tb-footer" className="bg-[#00663F] text-white py-16 px-6">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="flex-1 flex flex-col items-center md:items-start">
            <div className="flex max-w-[500px] items-center gap-2 cursor-pointer font-bold text-white">
              <img
                src={BusinessLogo}
                alt="Traderbot"
                className="w-8 h-8 rounded-full"
              />
              <span className="text-white text-xl">Traderbot by NGX</span>
            </div>
            <p className="text-[16px] text-white leading-relaxed mt-4 mb-5 text-center md:text-left">
              A secure and official WhatsApp channel by the Nigerian Exchange
              Group, designed to help you open trading accounts, complete KYC,
              and access market insights seamlessly from your mobile device.
            </p>
            <div className="flex justify-between gap-2.5">
              <span className="w-10 h-10 rounded-full bg-[#E5E5E5] flex items-center justify-center cursor-pointer hover:bg-green-600 transition-colors">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.3263 1.90381H21.6998L14.3297 10.3273L23 21.7898H16.2112L10.894 14.8378L4.80995 21.7898H1.43443L9.31743 12.7799L1 1.90381H7.96111L12.7674 8.25814L18.3263 1.90381ZM17.1423 19.7706H19.0116L6.94539 3.81694H4.93946L17.1423 19.7706Z"
                    fill="#111216"
                  />
                </svg>
              </span>
              <span className="w-10 h-10 rounded-full bg-[#E5E5E5] flex items-center justify-center cursor-pointer hover:bg-green-600 transition-colors">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_301_18)">
                    <path
                      d="M22.2283 0H1.77167C1.30179 0 0.851161 0.186657 0.518909 0.518909C0.186657 0.851161 0 1.30179 0 1.77167V22.2283C0 22.6982 0.186657 23.1488 0.518909 23.4811C0.851161 23.8133 1.30179 24 1.77167 24H22.2283C22.6982 24 23.1488 23.8133 23.4811 23.4811C23.8133 23.1488 24 22.6982 24 22.2283V1.77167C24 1.30179 23.8133 0.851161 23.4811 0.518909C23.1488 0.186657 22.6982 0 22.2283 0ZM7.15333 20.445H3.545V8.98333H7.15333V20.445ZM5.34667 7.395C4.93736 7.3927 4.53792 7.2692 4.19873 7.04009C3.85955 6.81098 3.59584 6.48653 3.44088 6.10769C3.28591 5.72885 3.24665 5.31259 3.32803 4.91145C3.40941 4.51032 3.6078 4.14228 3.89816 3.85378C4.18851 3.56529 4.55782 3.36927 4.95947 3.29046C5.36112 3.21165 5.77711 3.25359 6.15495 3.41099C6.53279 3.56838 6.85554 3.83417 7.08247 4.17481C7.30939 4.51546 7.43032 4.91569 7.43 5.325C7.43386 5.59903 7.38251 5.87104 7.27901 6.1248C7.17551 6.37857 7.02198 6.6089 6.82757 6.80207C6.63316 6.99523 6.40185 7.14728 6.14742 7.24915C5.893 7.35102 5.62067 7.40062 5.34667 7.395ZM20.4533 20.455H16.8467V14.1933C16.8467 12.3467 16.0617 11.7767 15.0483 11.7767C13.9783 11.7767 12.9283 12.5833 12.9283 14.24V20.455H9.32V8.99167H12.79V10.58H12.8367C13.185 9.875 14.405 8.67 16.2667 8.67C18.28 8.67 20.455 9.865 20.455 13.365L20.4533 20.455Z"
                      fill="#0A66C2"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_301_18">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span className="w-10 h-10 rounded-full bg-[#E5E5E5] flex items-center justify-center cursor-pointer hover:bg-green-600 transition-colors">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_301_45)">
                    <path
                      d="M24 12C24 5.37264 18.6274 0 12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24.0005 18.1354 24.0005 12H24Z"
                      fill="#0866FF"
                    />
                    <path
                      d="M16.7002 15.6672L17.3737 12H13.454V10.703C13.454 8.76526 14.2143 8.01982 16.1818 8.01982C16.7929 8.01982 17.2849 8.0347 17.5681 8.06446V4.74046C17.0314 4.59118 15.7196 4.44238 14.9593 4.44238C10.9493 4.44238 9.10087 6.3355 9.10087 10.4198V12H6.62646V15.6672H9.10087V23.6467C10.0292 23.8771 11.0002 24 11.9996 24C12.4916 24 12.9769 23.9697 13.4535 23.9121V15.6672H16.6997H16.7002Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_301_45">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
              <span className="w-10 h-10 rounded-full bg-[#E5E5E5] flex items-center justify-center cursor-pointer hover:bg-green-600 transition-colors">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_301_50)">
                    <path
                      d="M12 2.16094C15.2063 2.16094 15.5859 2.175 16.8469 2.23125C18.0188 2.28281 18.6516 2.47969 19.0734 2.64375C19.6313 2.85938 20.0344 3.12188 20.4516 3.53906C20.8734 3.96094 21.1313 4.35938 21.3469 4.91719C21.5109 5.33906 21.7078 5.97656 21.7594 7.14375C21.8156 8.40937 21.8297 8.78906 21.8297 11.9906C21.8297 15.1969 21.8156 15.5766 21.7594 16.8375C21.7078 18.0094 21.5109 18.6422 21.3469 19.0641C21.1313 19.6219 20.8687 20.025 20.4516 20.4422C20.0297 20.8641 19.6313 21.1219 19.0734 21.3375C18.6516 21.5016 18.0141 21.6984 16.8469 21.75C15.5813 21.8062 15.2016 21.8203 12 21.8203C8.79375 21.8203 8.41406 21.8062 7.15313 21.75C5.98125 21.6984 5.34844 21.5016 4.92656 21.3375C4.36875 21.1219 3.96563 20.8594 3.54844 20.4422C3.12656 20.0203 2.86875 19.6219 2.65313 19.0641C2.48906 18.6422 2.29219 18.0047 2.24063 16.8375C2.18438 15.5719 2.17031 15.1922 2.17031 11.9906C2.17031 8.78438 2.18438 8.40469 2.24063 7.14375C2.29219 5.97187 2.48906 5.33906 2.65313 4.91719C2.86875 4.35938 3.13125 3.95625 3.54844 3.53906C3.97031 3.11719 4.36875 2.85938 4.92656 2.64375C5.34844 2.47969 5.98594 2.28281 7.15313 2.23125C8.41406 2.175 8.79375 2.16094 12 2.16094ZM12 0C8.74219 0 8.33438 0.0140625 7.05469 0.0703125C5.77969 0.126563 4.90313 0.332812 4.14375 0.628125C3.35156 0.9375 2.68125 1.34531 2.01563 2.01562C1.34531 2.68125 0.9375 3.35156 0.628125 4.13906C0.332812 4.90313 0.126563 5.775 0.0703125 7.05C0.0140625 8.33437 0 8.74219 0 12C0 15.2578 0.0140625 15.6656 0.0703125 16.9453C0.126563 18.2203 0.332812 19.0969 0.628125 19.8563C0.9375 20.6484 1.34531 21.3188 2.01563 21.9844C2.68125 22.65 3.35156 23.0625 4.13906 23.3672C4.90313 23.6625 5.775 23.8687 7.05 23.925C8.32969 23.9812 8.7375 23.9953 11.9953 23.9953C15.2531 23.9953 15.6609 23.9812 16.9406 23.925C18.2156 23.8687 19.0922 23.6625 19.8516 23.3672C20.6391 23.0625 21.3094 22.65 21.975 21.9844C22.6406 21.3188 23.0531 20.6484 23.3578 19.8609C23.6531 19.0969 23.8594 18.225 23.9156 16.95C23.9719 15.6703 23.9859 15.2625 23.9859 12.0047C23.9859 8.74688 23.9719 8.33906 23.9156 7.05938C23.8594 5.78438 23.6531 4.90781 23.3578 4.14844C23.0625 3.35156 22.6547 2.68125 21.9844 2.01562C21.3188 1.35 20.6484 0.9375 19.8609 0.632812C19.0969 0.3375 18.225 0.13125 16.95 0.075C15.6656 0.0140625 15.2578 0 12 0Z"
                      fill="#000100"
                    />
                    <path
                      d="M12 5.83594C8.59688 5.83594 5.83594 8.59688 5.83594 12C5.83594 15.4031 8.59688 18.1641 12 18.1641C15.4031 18.1641 18.1641 15.4031 18.1641 12C18.1641 8.59688 15.4031 5.83594 12 5.83594ZM12 15.9984C9.79219 15.9984 8.00156 14.2078 8.00156 12C8.00156 9.79219 9.79219 8.00156 12 8.00156C14.2078 8.00156 15.9984 9.79219 15.9984 12C15.9984 14.2078 14.2078 15.9984 12 15.9984Z"
                      fill="#000100"
                    />
                    <path
                      d="M19.8469 5.59214C19.8469 6.38902 19.2 7.03121 18.4078 7.03121C17.6109 7.03121 16.9688 6.38433 16.9688 5.59214C16.9688 4.79526 17.6156 4.15308 18.4078 4.15308C19.2 4.15308 19.8469 4.79995 19.8469 5.59214Z"
                      fill="#000100"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_301_50">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </span>
            </div>
          </div>
          <div className="flex flex-1 flex-col items-center md:flex-row md:justify-between  gap-8 lg:gap-12 lg:justify-end">
            <div className="flex flex-col items-center md:items-start justify-start">
              <h5 className="text-lg lg:text-xl font-bold text-white mb-8">
                Product
              </h5>
              <button
                onClick={() => scrollTo("tb-features")}
                className="block bg-transparent border-none text-white text-base lg:text-lg p-0 mb-8 cursor-pointer text-left hover:text-white/60 transition-colors"
              >
                Features
              </button>
              <button
                onClick={() => scrollTo("tb-how")}
                className="block bg-transparent border-none text-white text-base lg:text-lg p-0 mb-8 cursor-pointer text-left hover:text-white/60 transition-colors"
              >
                How it Works
              </button>
              <button
                onClick={() => scrollTo("tb-footer")}
                className="block bg-transparent border-none text-white text-base lg:text-lg p-0 mb-8 cursor-pointer text-left hover:text-white/60 transition-colors"
              >
                Contact Us
              </button>
            </div>
            <div className="flex flex-col items-center md:items-start justify-start">
              <h5 className="text-lg lg:text-xl font-bold text-white mb-8">
                Resources
              </h5>
              <button
                onClick={() => scrollTo("tb-faq")}
                className="block bg-transparent border-none text-white text-base lg:text-lg p-0 mb-8 cursor-pointer text-left hover:text-white/60 transition-colors"
              >
                FAQs
              </button>
              <button className="block bg-transparent border-none text-white text-base lg:text-lg p-0 mb-8 cursor-pointer text-left hover:text-white/60 transition-colors">
                Privacy Policy
              </button>
              <button className="block bg-transparent border-none text-white text-base lg:text-lg p-0 mb-8 cursor-pointer text-left hover:text-white/60 transition-colors">
                Terms of Service
              </button>
            </div>
            <div className="flex flex-col items-center md:items-start justify-start">
              <h5 className="text-lg lg:text-xl font-bold text-white mb-8">
                Contact & Support
              </h5>
              <button className="block bg-transparent border-none text-white text-base lg:text-lg p-0 mb-8 cursor-pointer text-left hover:text-white/60 transition-colors">
                WhatsApp Support
              </button>
              <button className="block bg-transparent border-none text-white text-base lg:text-lg p-0 mb-8 cursor-pointer text-left hover:text-white/60 transition-colors">
                Email: support@ngxtraderbot.ng
              </button>
              <button className="block bg-transparent border-none text-white text-base lg:text-lg p-0 mb-8 cursor-pointer text-left hover:text-white/60 transition-colors">
                Help Center
              </button>
            </div>
          </div>
        </div>
        <div className="max-w-[1280px] mx-auto mt-10 pt-5 pb-6 border-t border-[#FFFFFF]/30 flex flex-col md:flex-row justify-between text-[14px] text-white gap-2 text-center md:text-left">
          <span>&copy; 2025 NGX Traderbot. All rights reserved.</span>
          <span>Powered by NGX & Traderbot</span>
        </div>
      </footer>
    </div>
  );
}
